import { InvoiceBillCrdb } from "../../../ifmsTypes";

// invoiceBill에서 statusBill, statusInvoice, statusCrdb를 업데이트하기 위함
export const shouldLockShipmentTypeField = (invoiceBill: InvoiceBillCrdb): boolean => {
  const getMblList = Object.values(invoiceBill).filter((list: any) => list);

  const nonVoidDataList = getMblList.map((arr: any) =>
    arr.filter((obj: any) => {
      if (arr === getMblList[0]) {
        return obj.void === 0;
      } else if (arr === getMblList[1]) {
        return obj.isVoid === 0;
      } else if (arr === getMblList[2]) {
        return obj.void === 0;
      }
      return 0;
    }),
  );

  const hasObjectInArray = (list: any[]): boolean => {
    return list.some((arr) => arr.length > 0);
  };

  // 'I' or 'D'가 하나라도 있을 때
  if (hasObjectInArray(nonVoidDataList)) {
    return true;
    // 'I' or 'D'가 없을 때
  } else {
    return false;
  }
};
